(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-for-availability-form"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    const params = new URLSearchParams(window.location.search);
    const productHandle = params.get("product");
    const productPrice  = params.get("price");
    const productTitle  = params.get("title");
    const productVariant = params.get("variant");

    if (productHandle) {
      let referrerType = "";
      if (document.referrer.includes("sternpinball.com") || document.referrer.includes("staging-sternpinball.kinsta.cloud")) {
        referrerType = document.referrer.includes("shop.sternpinball.com") ? "Shopify" : "WP";
      }

      fetch(`/products/${productHandle}.json`)
        .then(response => {
          if (!response.ok) {
            document.getElementById("contact-form-product-title").value = productTitle || "";
            document.getElementById("contact-form-product-price").value = productPrice || "";
            document.getElementById("variant").value = productVariant || "";
            document.getElementById("ip_family").value = productTitle || "";
            document.getElementById("product-url").value = `https://sternpinball.com/game/${productHandle}`;
            document.getElementById("shopType").value = referrerType;
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          if (!data || !data.product) throw new Error("Invalid product data received");

          document.getElementById("contact-form-product-title").value = data.product.title || "";

          const selectedVariant = data.product.variants.find(v =>
            v && v.title && productVariant && v.title.toLowerCase().includes(productVariant.toLowerCase())
          );

          if (selectedVariant) {
            document.getElementById("contact-form-product-price").value = selectedVariant.price || "";
            document.getElementById("variant").value = selectedVariant.title || "";
          } else {
            if (productPrice) {
              document.getElementById("contact-form-product-price").value = productPrice;
            }
            document.getElementById("variant").value = productVariant || '';
          }

          document.getElementById("ip_family").value = data.product.title || "";
          document.getElementById("product-url").value = `https://shop.sternpinball.com/collections/games/products/${data.product.handle}`;
          document.getElementById("shopType").value = referrerType;
        })
        .catch(err => { console.error("Product doesn't exist or API request failed:", err); });
    }
  });
  
  } catch(e) { console.error(e); }
})();
})();
